import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { fetchAllJobs, fetchAllJobsByRange, fetchAllTickets, fetchJobHasError, fetchupdateToKanbanBoard } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";
import DatePicker from "react-datepicker";
import ToggleSwitch from "../shared/ToggleSwitch";
import { getTimeDiff } from "../../utils/commonUtils";

const Ingestion = () => {

    const now = new Date()

    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    const localStartOfDayNow = new Date(now.getTime() - timezoneOffsetMs);
    localStartOfDayNow.setHours(0, 0, 0, 0);
    const [showMoreColumns, setShowMoreColumns] = useState(false);

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(false)

    const [selectedDate, setSelectedDate] = useState(localStartOfDayNow);

    const { ref, inView } = useInView();

    const queryKey = ['backlog', selectedDate, decouncedSearchValue];

    const checkIfJobHasError = async (item) => {
        const result = await fetchJobHasError({ fileName: item.pk })
        return {
            ...item, hasError: result.hasError,
            status: result.hasError && item.status === 'COMPLETED' ? 'ERROR' : item.status
        }
    }


    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,
        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchInterval: autoRefreshEnabled ? 1000 * 3 : false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: async ({ pageParam }) => {
            let params = { lastEvaluatedKey: pageParam };

            if (decouncedSearchValue) {
                params.fileNamePrefix = decouncedSearchValue
            }

            if (!selectedDate) {
                return fetchAllJobs(params)
            }

            //is in local time
            if (selectedDate) {
                selectedDate.setHours(0, 0, 0, 0);
                params.createdAt = selectedDate.toISOString()
            }

            const result = await fetchAllJobsByRange(params)
            const errorCheckTasks = result.Items.map(item => checkIfJobHasError(item))
            const items = await Promise.all(errorCheckTasks)

            return { ...result, Items: items }

        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items?.map(item => {
                    if (item.requestBody) {
                        try {
                            item.requestBodyParsed = JSON.parse(item.requestBody)
                        } catch (err) {
                            console.log(err)
                        }
                    }

                    if (item.startedAt && item.completedAt) {
                        const date1 = new Date(item.startedAt);
                        const date2 = new Date(item.completedAt);
                        item.duration = getTimeDiff({ date1, date2 })
                    }
                    return item
                })).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },

        staleTime: 0,//,Infinity,
        enabled: true  //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    // const resutls = data?.pages.flat()
    const items = data?.pages.flat();

    let columns = ['pk', 'count', 'startedAt', 'completedAt', 'duration', 'errorMessage.message', 'status',];

    if (showMoreColumns) {
        columns = [...columns, 'jobScheduleStartTime', 'scheduledByHostName', 'scheduledByPid', 'workerHostName', 'workerPid']
    }

    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 1);

    return (
        <div className="container">

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                    <p className="title">Ingestion</p>
                    <p className="sub-title">Edi to HRP ingestion.  </p>

                    <p className="sub-title">Search hints edi_enrollment_sparse | edi_837_IB_REPRICED | </p>

                </div>

                <div>
                    <ToggleSwitch
                        label={`Auto Refresh`}
                        onToggle={(val) => setAutoRefreshEnabled(val)}
                        initialState={autoRefreshEnabled}
                    />
                </div>
            </div>



            {/* {lastUpdatedAt} */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '.6rem' }}>

                        <label style={{ fontSize: '.9rem', color: 'var(--darkGrey)' }} htmlFor="date">Filter by Created at UTC date</label>
                        <DatePicker
                            className="date-picker"
                            placeholderText="Created at date "
                            inline={false}
                            dateFormat={'yyyy-MM-dd'}
                            selected={selectedDate}
                            onChange={(date) => {
                                setSelectedDate(date)
                            }}
                            maxDate={maxDate}
                        />
                        {/* <p style={{ paddingLeft: '.4rem' }}>Local: {selectedDate?.toLocaleString()}</p> */}

                    </div>
                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none", marginTop: '1.6rem' }}
                        type="text"
                        id={"search"}
                        placeholder="Case sensative File prefix ..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>

            {/* <p>{Intl.DateTimeFormat().resolvedOptions().timeZone}:{selectedDate?.toLocaleString()}</p>
            <p> UTC: {selectedDate?.toISOString()}</p> */}

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {


                        setSelectedDate(null);
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>
            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"edi-ingestion"}
                        columns={columns}
                        items={items}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default Ingestion